import { useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import { useI18n } from '@xdocs/ui';
import type { TranslateVars } from '@xdocs/i18n';
import type { NotificationsCatalogKey } from './notifications.i18n.js';
import { NOTIFICATIONS_CATALOG } from './notifications.i18n.js';

export type NotificationsMessageId = `notifications:${NotificationsCatalogKey}`;

const PREFIX_LENGTH = 'notifications:'.length;

/** `t()` for the stop-gap `notifications:` scope (see `notifications.i18n.ts`). */
export function useNotificationsT(): { t: (id: NotificationsMessageId, vars?: TranslateVars) => string } {
  const { locale } = useI18n();

  const t = useMemo(() => {
    return (id: NotificationsMessageId, vars?: TranslateVars): string => {
      const key = id.slice(PREFIX_LENGTH) as NotificationsCatalogKey;
      const raw = NOTIFICATIONS_CATALOG[locale][key] ?? NOTIFICATIONS_CATALOG.en[key];
      if (!vars) return raw;
      const formatted = new IntlMessageFormat(raw, locale).format(vars);
      if (formatted == null) return '';
      if (typeof formatted === 'string') return formatted;
      return Array.isArray(formatted) ? formatted.map(String).join('') : String(formatted);
    };
  }, [locale]);

  return { t };
}
